export interface Blinker {
  id: number;
  name: string;
  manufacturer: string;
}

export interface DeviceClass {
  type: string;
  title: string;
  status: number;
  traceId: string;
}

export interface DisplayTestingClass {
  deviceId: number;
  stellcode: number;
  deKanal: number;
  indicator: number;
  flashingtime: number;
  anzeigeprinzip: number;
}

export interface GroupClass {
  add: string[];
  delete: string[];
}

export interface JsonUploadClass {
  deviceId: number;
  fileContent: string;
  targetPath: string;
  fileName: string;
  deKanal: number | null;
  routeStationId: string;
}

export interface ProjectRouteStationImageClass {
  routeStationId: string;
  imageId: number;
  projectId: number;
  stellcode: number;
  path: string;
  isCustom: boolean;
  projectRouteStationImageId: number;
}

export interface Role {
  id: number;
  name: string;
}

export interface UserBasicInfo {
  username: string;
  email: string;
  password: string;
  roleID: number;
  roleText: string;
}

export enum RoleDetails {
  Monteur = 3,
  Mitarbeiter = 2,
  Admin = 1,
}
